import { TimeKeeperProps, useTimeKeeper } from "components/routes/events/useTimeKeeper";


export const Timer = ({ start, duration, remainingMillisecondsOnPause, resume, tickInterval }: TimeKeeperProps) => {
    const remainingTime = useTimeKeeper({ start, duration, remainingMillisecondsOnPause, resume, tickInterval });

    const pad = (num: number) => (num.toString().length === 1 ? "0" + num : num);

    const remainingMinutes = remainingTime.hours() * 60 + remainingTime.minutes();

    return (
        <div
            className={`timer-wrapper ${
                remainingTime.asMilliseconds() <= 5 * 60000 && duration >= 10 ? "warning" : ""
            }`}
        >
            <div className="display-time" data-testid="display-time">
                {`${pad(remainingMinutes)}:${pad(remainingTime.seconds())}`}
            </div>
        </div>
    );
};
